<template>
  <div>
    <el-row>
      <el-form :model="ruleForm" ref="ruleForm" label-width="70px" style="overflow: hidden;margin-top:30px"
        class="demo-ruleForm">
        <el-col :span="5">
          <el-form-item label="开始日期" prop="startTime">
            <el-date-picker v-model="ruleForm.startTime" @change="startTime" align="right" type="date"
              placeholder="选择开始日期" format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="结束日期" prop="endTime">
            <el-date-picker v-model="ruleForm.endTime" @change="endTime" align="right" type="date"
              placeholder="选择结束日期" format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="searchStr" style="margin-left: 0px;">
            <el-button type="primary" @click="search2" style="margin-left:20px;">搜索</el-button>
            <el-button type="primary" @click="resetFprm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <div class="table-body">
      <div class="table-batch">
        <el-button type="primary" @click="dialogVisible=true">
          批量导入货态
        </el-button>
      </div>
      <div class="table-list">

        <div style="display: flex;">
          <div style="margin-bottom: 15px; margin-left: 8px;width: 360px;">
            渠道：
            <el-radio-group v-model="ruleForm.channelType" @change="changeChannel">
              <el-radio-button :label="17">柏电</el-radio-button>
              <el-radio-button :label="19">万立德</el-radio-button>
              <el-radio-button :label="20">浩亿达</el-radio-button>
              <el-radio-button :label="21">琪悦</el-radio-button>
            </el-radio-group>
          </div>
          
          <div style="margin-bottom: 15px; margin-left: 38px;width: calc(100% - 220px);" v-if="countryList.length">
            国家：
            <el-radio-group v-model="ruleForm.countryMark" @change="search2">
              <el-radio-button v-for="item in countryList" :key="item.countryMark" :label="item.countryMark">{{ item.countryName }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        
        <el-table width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading" :span-method="spanMethod" stripe v-if="ruleForm.channelType==17">
          <el-table-column prop="harvestTime" label="收货时间" align="center" width="100" fixed="left"></el-table-column>
          <!-- <el-table-column prop="countryName" label="国家" align="center" width="120" />
          <el-table-column prop="channelType" label="渠道" align="center"></el-table-column> -->
          <el-table-column label="签收">
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.receiptCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.receiptRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.receiptCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.receiptRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="退仓">
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.returnCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.returnRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.returnCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.returnRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="退仓上架">
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.checkOutCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.checkOutRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.checkOutCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.checkOutRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="销毁">
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.destroyCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.destroyRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.destroyCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.destroyRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="转运中">
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.transitCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="baidianReassignCargoStatuEvent.baidianCargoStatuEvent.transitRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.transitCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="baidianUnReassignCargoStatuEvent.baidianCargoStatuEvent.transitRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="汇总(%)" fixed="right" width="500">
            <el-table-column
              prop="count"
              label="总数"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="baidianReturnSumRate"
              label="退仓率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="baidianReceiptSumRate"
              label="签收率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="baidianTransitSumRate"
              label="转运中率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="baidianCheckOutSumRate"
              label="退仓上架率"
              fixed="right"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              prop="baidianDestroySumRate"
              label="销毁率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-table width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading" :span-method="spanMethod" stripe v-else-if="ruleForm.channelType==19">
          <el-table-column prop="harvestTime" label="收货时间" align="center" width="100" fixed="left"></el-table-column>
          <!-- <el-table-column prop="countryName" label="国家" align="center" width="120" />
          <el-table-column prop="channelType" label="渠道" align="center"></el-table-column> -->
          <el-table-column label="签收">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.receiptCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.receiptRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.receiptCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.receiptRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="退仓">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.returnCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.returnRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.returnCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.returnRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="退仓上架">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.checkOutCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.checkOutRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.checkOutCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.checkOutRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="销毁">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.destroyCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.destroyRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.destroyCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.destroyRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="转运中">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.transitCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.transitRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.transitCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.transitRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="到达待取">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="派送中">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.deliveringCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.deliveringRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.deliveringCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.deliveringRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="待转运">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="汇总(%)" fixed="right" width="760">
            <el-table-column
              prop="count"
              label="总数"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldReturnSumRate"
              label="退仓率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldReceiptSumRate"
              label="签收率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldTransitSumRate"
              label="转运中率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldCheckOutSumRate"
              label="退仓上架率"
              fixed="right"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldDestroySumRate"
              label="销毁率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldPendingSumRate"
              label="到达待取率"
              fixed="right"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldDeliveringSumRate"
              label="派送中率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldPendingTransferSumRate"
              label="待转运率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-table width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading" :span-method="spanMethod" stripe v-else-if="ruleForm.channelType==20">
          <el-table-column prop="harvestTime" label="收货时间" align="center" width="100" fixed="left"></el-table-column>
          <!-- <el-table-column prop="countryName" label="国家" align="center" width="120" />
          <el-table-column prop="channelType" label="渠道" align="center"></el-table-column> -->
          <el-table-column label="签收">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.receiptCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.receiptRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.receiptCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.receiptRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="退仓">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.returnCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.returnRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.returnCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.returnRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="退仓上架">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.checkOutCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.checkOutRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.checkOutCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.checkOutRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="销毁">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.destroyCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.destroyRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.destroyCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.destroyRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="转运中">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.transitCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.transitRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.transitCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.transitRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="到达待取">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="派送中">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.deliveringCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.deliveringRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.deliveringCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.deliveringRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="待转运">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="汇总(%)" fixed="right" width="760">
            <el-table-column
              prop="count"
              label="总数"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldReturnSumRate"
              label="退仓率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldReceiptSumRate"
              label="签收率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldTransitSumRate"
              label="转运中率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldCheckOutSumRate"
              label="退仓上架率"
              fixed="right"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldDestroySumRate"
              label="销毁率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldPendingSumRate"
              label="到达待取率"
              fixed="right"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldDeliveringSumRate"
              label="派送中率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldPendingTransferSumRate"
              label="待转运率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-table width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading" :span-method="spanMethod" stripe v-else-if="ruleForm.channelType==21">
          <el-table-column prop="harvestTime" label="收货时间" align="center" width="100" fixed="left"></el-table-column>
          <!-- <el-table-column prop="countryName" label="国家" align="center" width="120" />
          <el-table-column prop="channelType" label="渠道" align="center"></el-table-column> -->
          <el-table-column label="签收">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.receiptCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.receiptRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.receiptCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.receiptRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="退仓">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.returnCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.returnRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.returnCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.returnRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="退仓上架">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.checkOutCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.checkOutRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.checkOutCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.checkOutRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="销毁">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.destroyCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.destroyRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.destroyCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.destroyRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="转运中">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.transitCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.transitRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.transitCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.transitRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="到达待取">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="派送中">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.deliveringCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.deliveringRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.deliveringCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.deliveringRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="待转运">
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferCount"
              label="重派"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="wldReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferCount"
              label="非重派"
              align="center"
              width="66">
            </el-table-column>
            <el-table-column
              prop="wldUnReassignCargoStatuEvent.wldCargoStatuEvent.pendingTransferRate"
              label="占比(%)"
              align="center"
              width="76">
            </el-table-column>
          </el-table-column>
          <el-table-column label="汇总(%)" fixed="right" width="760">
            <el-table-column
              prop="count"
              label="总数"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldReturnSumRate"
              label="退仓率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldReceiptSumRate"
              label="签收率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldTransitSumRate"
              label="转运中率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldCheckOutSumRate"
              label="退仓上架率"
              fixed="right"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldDestroySumRate"
              label="销毁率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldPendingSumRate"
              label="到达待取率"
              fixed="right"
              width="100"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldDeliveringSumRate"
              label="派送中率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wldPendingTransferSumRate"
              label="待转运率"
              fixed="right"
              width="80"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <div class="page">
      <el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :current-page="currentPage" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <el-dialog
      title="导入COD货态"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleUploadExcelDialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-row :gutter="20" style="padding-left: 20px;margin-bottom: 20px">
        渠道：
        <el-select v-model="logistics">
          <el-option v-for="item in listLogistics"
            :key="item.id"
            :label="item.itemTypeName"
            :value="item.itemTypeId">
          </el-option>
        </el-select>
      </el-row>
      <el-row type="flex" align="middle">
        <upload-excel-component :on-success="handleUploadExcelSuccess"/>
        <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
      </el-row>
      <div class="file-box">
        <span style="color: red">注意：时间格式按照“2022/10/10”填写</span>
      </div>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${ index + 1 }. ${ item.fileName }` }}</div>
      </div>
      <div class="file-box" v-show="errorList">
        <span><span style="color: red">导入异常运单号：</span>{{ errorList }}</span>
      </div>
      <div slot="footer">
        <el-button
          size="small"
          @click="handleUploadExcelSubmit"
          :loading="btnLoading"
        >确定导入
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxPost, Baseurl } from '../../api/api/api'
export default {
  name: 'COMparticulars',
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 5,
      size: 20,
      total: 0,
      ruleForm: {
        countryMark: '',
        status: '',
        startTime: '',
        endTime: '',
        channelType: 17
      },
      tableData: [],
      loading: false,
      countryList: [],
      dialogVisible: false,
      btnLoading: false,
      listFile: [],
      returnList: [],
      errorList: '',
      listLogistics: [],
      logistics: ''
    }
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.getLogisticsList()
    this.changeChannel()
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.returnList = []
      }
    }
  },
  methods: {
    changeChannel() {
      const API = Baseurl + 'codCargoStatusController/getCountryList'
      const paramsData = {
        channelType: this.ruleForm.channelType,
        rid: this.str.rid
      }
      ajaxPost(API, paramsData).then((res) => {
        const {code, data} = res.data
        if (code === 200 && data.length) {
          this.countryList = data
          this.ruleForm.countryMark = data[0].countryMark
          this.search2()
        } else {
          this.countryList = []
          this.tableData = []
        }
      }).catch(() => {
        this.countryList = []
        this.tableData = []
      })
    },
    getLogisticsList() {
      const API = Baseurl + 'purchaseController/selectItemList'
      const paramsData = {
        itemCode: 'HYXUN0000007',
      }
      ajaxPost(API, paramsData).then((res) => {
        const {code, data} = res.data
        if (code === 200) {
          this.listLogistics = data
        }
      })
    },
    handleUploadExcelSubmit() {
      if (!this.logistics) {
        this.$message.error("请选择渠道！")
        return
      }
      if (!this.returnList.length) {
        this.$message.error("请先导入文件！")
        return
      }
      this.btnLoading = true
      ajaxPost(
        Baseurl + 'codCargoStatusController/importCodCargoStatus/'+this.str.rid+'/'+this.logistics, this.returnList
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("成功导入"+res.data.data.successCount+"条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList.join(",")
          } else {
            this.dialogVisible = false
            this.listFile = []
            this.errorList = ''
          }
          this.changeChannel()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnLoading = false
      })
    },
    formatDate(numb, format) {
      const old = numb - 1;
      const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
      const time = new Date(1900, 0, old, 0, 0, t)
      const year = time.getFullYear() ;
      const month = time.getMonth() + 1 ;
      const date = time.getDate();
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
    },
    handleUploadExcelSuccess({ results, header, fileName }) {
      let returnList = results.map(item => ({
        orderChannelId: item.客户订单号,
        conveyNumber: item.运单号,
        channelWay: item.渠道方式,
        status: item.状态,
        harvestTime: this.formatDate(item.收货时间, '-')
      }))
      let bool = false
      returnList.map(item => {
        if (item.destroyTime == "NaN-NaN-NaN" || item.noticeTime == "NaN-NaN-NaN") {
          bool = true
        }
      })
      if (bool == true) {
        this.$message.error("时间格式有误，请按照正确格式填写！")
        return
      }
      this.returnList.push(...returnList)
      this.listFile.push({fileName})
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/COD%E8%B4%A7%E6%80%81%E8%A1%A8%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/COD%E8%B4%A7%E6%80%81%E8%A1%A8%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelDialogClose() {
      this.dialogVisible = false
      this.listFile = []
      this.errorList = ''
    },
    startTime(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate()
      this.ruleForm.startTime = datetime
    },
    // 选择结束时间
    endTime(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate()
      this.ruleForm.endTime = datetime
    },
    search2() {
      this.currentPage = 1
      this.search()
    },
    search() {
      this.loading = true
      // 库存列表
      var obj = {
        page: this.currentPage,
        size: this.size,
        ...this.ruleForm,
        channelType: this.ruleForm.channelType ? Number(this.ruleForm.channelType) : '',
        rid: this.str.rid
      }
      ajaxPost(
        Baseurl + 'codCargoStatusController/pageInfo',
        obj
      ).then((res) => {
        if (res.data.code === 200) {
          this.tableData = []
          this.manage(res.data.data.list)
          this.total = res.data.data.total
        }
        this.loading = false
      })
    },
    manage(tableData) {
      tableData.map(item => {
        if (item.countryCodCargoStatusEvents && item.countryCodCargoStatusEvents.length) {
          item.countryCodCargoStatusEvents.map(ele => {
            let obj = JSON.parse(JSON.stringify(item))
            this.$set(obj, 'countryName', ele.countryName)
            this.$set(obj, 'channelCodCargoStatusEvents', ele.channelCodCargoStatusEvents)
            ele.channelCodCargoStatusEvents.map(el => {
              let obj1 = JSON.parse(JSON.stringify(el))
              Object.assign(obj, obj1)
              this.$set(obj, 'channelType', el.channelType)
              this.tableData.push(obj)
            })
          })
        } else {
          this.tableData.push(item)
        }
      })
      // this.spanMethod()
    },
    spanMethod(data) {
      if (!data) return
      // const num = data.row.countryCodCargoStatusEvents.length === 0 ? 1 : data.row.countryCodCargoStatusEvents.length
      // const arr = [0]
      // if (arr.includes(data.columnIndex)) {
      //   if (
      //     data.rowIndex > 0 &&
      //     data.row.id === this.tableData[data.rowIndex - 1].id
      //   ) {
      //     return {
      //       rowspan: 0,
      //       colspan: 0
      //     }
      //   } else {
      //     return {
      //       rowspan: num,
      //       colspan: 1
      //     }
      //   }
      // }
    },
    resetFprm(formName) {
      this.$refs[formName].resetFields();
      this.currentPage = 1
      this.search()
    },
    handleSizeChange(val) {
      this.size = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .layout .layout-section ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #b71e1e;
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }

  .el-divider--horizontal {
    margin: 15px 0;
  }
}

.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.details_left {
  width: 30%;
  text-align: center;
}
.details_right {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.table-body {
	width: 100%;
	border: 1px solid #eee;
	overflow: hidden;
}
.table-batch {
  box-sizing: border-box;
  text-align: right;
  padding-right: 20px;
	width: 100%;
	overflow: hidden;
	height: 40px;
	line-height: 40px;
	padding-left: 25px;
}

.information {
  width: 98%;
  overflow: hidden;
  margin-bottom: 50px;
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 300px;
  height: 300px;
}

.padding {
  padding: 5px 0;
}

.line-height {
  line-height: 35px;
}

.page {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 99;
}

.textlang {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.file-box {
  padding-top: 20px;
}
</style>
